import Component from '@bythepixel/component-loader';

export default class openLightbox extends Component {
  static selector = '[comp-lightbox-ctrl]'

  constructor(...args) {
    super(...args);
    this.DOMEvent = 'click';
    this.eventName = this.$container.getAttribute('comp-lightbox-ctrl') === 'close' ? 'lightbox:close' : 'lightbox:open';
    this.$container.addEventListener(this.DOMEvent, e => this.$publish(this.eventName, this.$container.dataset, e));
  }
}
